import { isEmpty } from 'lodash'

export const getLabelByValue = (list, value) => {
  if (isEmpty(list)) {
    return null
  }

  return list.find(item => item?.value === value)?.label
}
